'use client';

import { PasskeySettings as PasskeySettingsComponent } from '@verifime/components';
import { useEffect } from 'react';
import { usePasswordless } from './hooks/usePasswordless';

export default function PasskeySettings({
  openSetupDialog = false,
  onPasskeyRegistered,
}: Readonly<{
  openSetupDialog?: boolean;
  onPasskeyRegistered?: () => void;
}>) {
  const { fido2CreateCredential, fido2Credentials } = usePasswordless();

  useEffect(() => {
    if ((fido2Credentials?.length ?? 0) < 1) {
      return;
    }

    onPasskeyRegistered?.();
  }, [fido2Credentials, onPasskeyRegistered]);

  return (
    <PasskeySettingsComponent
      credentials={fido2Credentials ?? []}
      handleAddNew={(newName: () => Promise<string>) =>
        fido2CreateCredential({ friendlyName: newName }).then(() => {})
      }
      handleRemove={(index) => fido2Credentials![index].delete()}
      handleRename={(index, newName) => fido2Credentials![index].update({ friendlyName: newName })}
      openSetupDialog={openSetupDialog}
    />
  );
}
